import React from 'react';
import Nav from '../MEP/SWNav';
import {Navigate} from 'react-router-dom'
import FooterSW from '../MEP/footer_SW';
import viti2 from '../../assets/Site_Web/cartes_CC_viti_plus2degre.png'
import viti4 from '../../assets/Site_Web/cartes_CC_viti_plus4degre.png'
import methodo from '../../assets/Site_Web/process-diagorisk.png'
import tablette from '../../assets/Site_Web/tablette_territorial_ble_cdvl.png'
import pc from '../../assets/Site_Web/pc_35_50_capture.png'

function DiagnosticsClimatiques() {
  const [goToContact, setGoToContact] = React.useState(false)
  function handleContacter(event){
    event.preventDefault()
    setGoToContact(true)
  }
  if(goToContact) {
    return <Navigate push to={`/nouscontacter`} />
  }
  return (
    <div>
      <Nav/>
      <div className="containerSW" >
        <h1 className="propositionValeur titreSW"><>Territorial ou individuel, faites votre diagnostic<br />climatique avec DiagoRisk</> </h1>
        <div className='paragraphe paragrapheLanding titre_centre' style={{fontWeight:'bold'}}>Réalisez votre Diagnostic Climat  à horizon 2035 ou 2050. Nous vous aidons à l’élaboration de votre stratégie collective d’adaptation au changement climatique. </div>
        <div className='row' style={{justifyContent:'space-evenly', marginBottom:'50px'}}>
          <img src={viti2} alt="cartes risques du vignoble français" className='carte_viti_diag'/>
          <img src={viti4} alt="cartes risques du vignoble français" className='carte_viti_diag'/>
        </div>
        

        <div className='principal principal3' style={{marginTop:'60px'}}>
            <div className='bottom bottom2 projetbloc1' >
              <div className='paragraphe paragrapheLanding'>Nous vous accompagnons dans cette démarche selon vos besoins :</div>
              <ul className='paragraphe paragrapheLanding'>
                <li className='ligne'> <div className='paragraphe paragrapheLanding'>Réaliser un diagnostic territorial</div></li>
                <li className='ligne'> <div className='paragraphe paragrapheLanding'>Animer la réflexion de votre stratégie d’adaptation</div></li>
                <li className='ligne'> <div className='paragraphe paragrapheLanding'>Décliner cette stratégie chez chacun de vos partenaires agriculteurs, en tenant compte de leurs spécificités.</div></li>
              </ul>
              <div className='paragraphe paragrapheLanding' style={{marginBottom:'15px', borderTop:'1px solid #C8C8C8', paddingTop:'15px'}}>
                Notre démarche s'appuie sur notre outil de modélisation, les recommandations de <strong>guides de l'ADEME</strong> (dont nous sommes coauteurs) et l'accompagnement de plusieurs filières.
              </div>
              <div className='row' style={{width:'100%'}}>
                <button className='validation validationAccueil buttonConnexionNav' onClick={handleContacter}>Contactez-nous</button>
              </div>
            </div>
            <div className='top topBBis projetbloc2' style={{display:'flex', justifyContent:'center'}}>
               <img src={methodo} alt='méthode de diagorisk'  className='method'/>
            </div>
          </div>

          <div className="principal_bloc_vert" >
            <div className='principal principal3' style={{padding: '40px 0'}}>
              <div className="bottom bottom2 projetbloc1" style={{marginBottom:'10px'}}>
                <img src={tablette} alt='OAD sur tablette tactile' style={{width:'100%'}}/>
              </div>
              <div className='top top1 top1_column'>
                <div className='paragraphe' style={{color:'#92D050', fontWeight:'bold'}}> POUR LES ORGANISATIONS</div>
                <h2 className='sous-Titre-SW' style={{textAlign:'start', marginTop:'5px'}}> <span style={{color:'black'}}>Les diagnostics</span> collectifs</h2>
                <div className='row row2' style={{textAlign:'left'}}>
                  <div style={{backgroundColor:'white', borderRadius:'10px', padding:'16px', flex:1, margin:'8px', border:'1px solid #83BE29', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)'}}>
                    <h3 className='paragraphe paragrapheLanding' style={{fontWeight:'bold', marginBottom:'8px', marginTop:'5px'}}>
                      <span style={{color:'#92D050', fontSize:'16px', marginRight:'8px'}}>●</span>
                      Fillière et territoires
                    </h3>
                    <div className='paragraphe paragrapheLanding' style={{marginBottom:'8px'}}> Anticiper les évolutions climatiques et sanitaires :</div>
                    <ul className='paragraphe paragrapheLanding' style={{marginTop:'0px', paddingLeft:'16px'}}>
                    <li><div className='paragraphe paragrapheLanding lila'>Objectiver les enjeux et les incertitudes majeures</div></li>
                    <li><div className='paragraphe paragrapheLanding lila'>Localiser les impacts pour chaque maillon</div></li>
                    <li><div className='paragraphe paragrapheLanding lila'>S'organiser pour pérenniser</div></li>
                  </ul>
                  </div>
                  <div style={{backgroundColor:'white', borderRadius:'10px', padding:'16px', flex:1, margin:'8px', border:'1px solid #83BE29', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)'}}>
                    <h3 className='paragraphe paragrapheLanding' style={{fontWeight:'bold', marginBottom:'8px', marginTop:'5px'}}>
                      <span style={{color:'#92D050', fontSize:'16px', marginRight:'8px'}}>●</span>
                      IAA, Coop et négoces
                    </h3>
                    <div className='paragraphe paragrapheLanding' style={{marginBottom:'8px'}}>Sécuriser son activité à court et moyen termes</div>
                    <ul className='paragraphe paragrapheLanding' style={{marginTop:'0px', paddingLeft:'16px'}}>
                      <li><div className='paragraphe paragrapheLanding lila'>Objectiver les variabilités et le coût de l'inaction</div></li>
                      <li><div className='paragraphe paragrapheLanding lila'>Sécuriser ses approvisionnements et sa collecte</div></li>
                      <li><div className='paragraphe paragrapheLanding lila'>Investir au bon moment, au bon endroit</div></li>
                      <li><div className='paragraphe paragrapheLanding lila'>Mobiliser ses partenaires, adhérents, fournisseurs par un juste partage des risques</div></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          
          <div className='principal principal3' style={{padding: '40px 0'}}>
            
            <div className='top top1 top1_column' >
              <div className='paragraphe' style={{color:'#92D050', fontWeight:'bold'}}> POUR LES AGRICULTEURS</div>
              <h2 className='sous-Titre-SW' style={{textAlign:'start', marginTop:'5px'}}> <span style={{color:'black'}}>Les diagnostics</span> individuels</h2>
              <div style={{display:'flex', flexDirection:'column', alignItems:'stretch'}}>
                <div style={{backgroundColor:'#FAFAFA', borderRadius:'10px', padding:'16px', marginTop:'0px', border:'0.5px solid #818181', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)', display:'flex', alignItems:'center', gap:'16px', minHeight:'80px'}}>
                  <div style={{minWidth:'48px', height:'48px', borderRadius:'50%', backgroundColor:'#92D050', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:'bold', fontSize:'20px'}}>1</div>
                  <div className='paragraphe paragrapheLanding'>Optimiser son assolement et sa gestion des risques</div>
                </div>

                <div style={{backgroundColor:'#FAFAFA', borderRadius:'10px', padding:'16px', marginTop:'20px', border:'0.5px solid #818181', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)', display:'flex', alignItems:'center', gap:'16px', minHeight:'80px'}}>
                  <div style={{minWidth:'48px', height:'48px', borderRadius:'50%', backgroundColor:'#92D050', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:'bold', fontSize:'20px'}}>2</div>
                  <div className='paragraphe paragrapheLanding'>Choisir les solutions les plus efficaces face au changement climatique et aux transitions</div>
                </div>

                <div style={{backgroundColor:'#FAFAFA', borderRadius:'10px', padding:'16px', marginTop:'20px', border:'0.5px solid #818181', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)', display:'flex', alignItems:'center', gap:'16px', minHeight:'80px'}}>
                  <div style={{minWidth:'48px', height:'48px', borderRadius:'50%', backgroundColor:'#92D050', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:'bold', fontSize:'20px'}}>3</div>
                  <div className='paragraphe paragrapheLanding'>Avoir une stratégie Climat–Carbone-Sol cohérente</div>
                </div>
              </div>
            </div>

            <div className="bottom bottom2 projetbloc1">
                <img src={pc} alt='OAD sur tablette tactile' style={{width:'100%'}}/>
              </div>
          </div>
          

        </div>
      <FooterSW/>
    </div>
  );
}

export default DiagnosticsClimatiques;

